import { render, staticRenderFns } from "./table-action-column.vue?vue&type=template&id=79632568"
import script from "./table-action-column.vue?vue&type=script&lang=js"
export * from "./table-action-column.vue?vue&type=script&lang=js"
import style0 from "./table-action-column.vue?vue&type=style&index=0&id=79632568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports